package one.devsbox.commons

import kotlin.enums.EnumEntries

/**
 * ```
 * enum class Status(override val code: Int) : EType {
 *     SUCCESS(2),
 *     PARTIAL(4),
 *     ERROR(8);
 *
 *     companion object : EType.Finder<Status>(entries)
 * }
 * ```
 *
 * ```
 * val status = Status[200] // Returns Status.SUCCESS
 * val status = Status.SUCCESS match 2 // Returns true
 * val status = Status.SUCCESS match 6 // Returns true (SUCCESS + PARTIAL)
 * val statuses = Status matches 6 // Returns listOf(SUCCESS, PARTIAL)
 * ```
 */
interface EType {
    val mask: Int

    operator fun <T : EType> plus(entry: T): Int = entry.mask + this.mask

    infix fun match(mask: Int): Boolean = this.mask and mask > 0

    infix fun notMatch(mask: Int): Boolean = !match(mask)

    abstract class Finder<T>(private val entries: EnumEntries<T>) where T : Enum<T>, T : EType {
        operator fun get(mask: Int): T? = entries.firstOrNull { it.mask == mask }
        infix fun matches(mask: Int): List<T> = entries.filter { it match mask }

    }
}